
  import Events from '@/events/Events';
  import axios from 'axios';
  export default {
    name: 'SectionMauticForms',
    components: {
      RichText: () => import('@/components/elements/RichText'),
      CheckboxRichText: () => import('@/components/elements/CheckboxRichText'),
      CustomBigTitle: () => import('@/components/CustomBigTitle'),
    },
    props: {
      section: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    data() {
      return {
        availableTopics: [
          this.$t('general_question.topics_general_request'),
          this.$t('general_question.topics_order_job_advertisement_package'),
          this.$t('general_question.topics_order_job_advertisement_quota'),
          this.$t(
            'general_question.topics_order_special_forms_of_advertising_features'
          ),
          this.$t('general_question.topics_order_booster_campaign'),
          this.$t('general_question.topics_order_pb_quota_search'),
          this.$t('general_question.topics_help'),
          this.$t('general_question.topics_new_registration'),
          this.$t('general_question.topics_invoices'),
          this.$t('general_question.topics_master_data_change'),
          this.$t('general_question.topics_appointment_request_consultation'),
          this.$t('general_question.topics_misc'),
        ],
        formData: {
          firstName: '',
          lastName: '',
          organization: '',
          email: '',
          checkbox: false,
        },
        disabled: false,
      };
    },
    methods: {
      getSectionColor() {
        let color = '#0D223F';
        if (this.section.background_color === 'gray') {
          color = '#f2f2f2';
        }
        return color;
      },

      async sendMauticForm() {
        this.disabled = true;
        setTimeout(() => (this.disabled = false), 3000);

        const formIdMapping = {
          newsletter: process.env.NUXT_ENV_MAUTIC_FORMS_NEWSLETTER_FORM_ID,
          pricelist: process.env.NUXT_ENV_MAUTIC_FORMS_PRICELIST_FORM_ID,
          preisliste: process.env.NUXT_ENV_MAUTIC_FORMS_PRICELIST_FORM_ID, // wegen alter deutscher Typ-Bezeichnung in Strapi
          contactform: process.env.NUXT_ENV_MAUTIC_FORMS_CONTACTFORM_FORM_ID,
        };

        let mauticForm = {
          firstname: this.formData.firstName,
          lastname: this.formData.lastName,
          email: this.formData.email,
          organization: this.formData.organization,
          formName: 'webseite' + this.section.form_type,
          formId: formIdMapping[this.section.form_type],
          messenger: 1,
        };

        if (['contactform'].includes(this.section.form_type)) {
          mauticForm = {
            ...mauticForm,
            phone: this.formData.phone,
            topic: this.formData.topic,
            form_message: this.formData.message,
          };
        }
        const self = this;
        axios
          .post(
            process.env.NUXT_ENV_MAUTIC_FORMS,
            {
              mauticform: mauticForm,
            },
            {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
              },
            }
          )
          .then((response) => {
            if (
              response.status === 200 &&
              response.data.indexOf('FormSubmissionSuccess') !== -1
            ) {
              self.$notifications.showNotification({
                message:
                  this.section && this.section.success_message
                    ? this.section.success_message
                    : this.$t('mautic_form.success_message'),
                color: 'success',
                timeout: 5000,
              });
              this.$emitWithClientData(Events.MauticFormSent, {
                formName: 'webseite' + this.section.form_type,
              });
              self.$refs.mauticForm.resetValidation();
              self.$refs.mauticForm.$children.forEach((child) => {
                if (Object.prototype.hasOwnProperty.call(child, 'reset')) {
                  child.reset();
                }
              });
              self.formData = {
                firstName: '',
                lastName: '',
                organization: '',
                email: '',
                checkbox: false,
              };
            } else {
              self.$notifications.showNotification({
                message: this.$t('mautic_form.error_message'),
                color: 'error',
                timeout: 5000,
              });
            }
          })
          .catch(() => {
            self.$notifications.showNotification({
              message: this.$t('mautic_form.error_message'),
              color: 'error',
              timeout: 5000,
            });
          });
      },
    },
  };
